import React from 'react';
import { Popup } from 'semantic-ui-react';
import styled from 'styled-components';
import { ProcoreTextCell } from './ProcoreTableCells';

interface ITruncatedTextCellProps {
    text: string;
    maxWidth?: string;
    maxLength?: number;
}

const TruncatedTextCell: React.FC<ITruncatedTextCellProps> = ({ 
    text, 
    maxWidth = '200px', 
    maxLength = 50 
}) => {
    const shouldTruncate = text.length > maxLength;
    const truncatedText = shouldTruncate ? `${text.substring(0, maxLength)}...` : text;

    if (shouldTruncate) {
        return (
            <Popup
                content={text}
                trigger={
                    <StyledTruncatedWrapper maxWidth={maxWidth}>
                        <ProcoreTextCell text={truncatedText} />
                    </StyledTruncatedWrapper>
                }
                position="top center"
                inverted
            />
        );
    }

    return (
        <StyledTruncatedWrapper maxWidth={maxWidth}>
            <ProcoreTextCell text={text} />
        </StyledTruncatedWrapper>
    );
};

const StyledTruncatedWrapper = styled.div<{ maxWidth: string }>`
    max-width: ${props => props.maxWidth};
    overflow: hidden;
    
    & > div {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;

export default TruncatedTextCell;
